import React from 'react';
import {
  TextField as MuiTextField, TextFieldProps
} from '@mui/material';

import styles from './TextField.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const CN = 'text-field';
const inputClassName = `${CN}__input`;

export const TextField: React.FC<TextFieldProps> = ({
  className,
  InputProps,
  ...props
}) => (
  <MuiTextField
    size='small'
    className={ `${cx(CN)} ${className}` }
    InputProps={ { ...InputProps, className: cx(inputClassName) } }
    { ...props }
  />
);
